import React from 'react'

const SvgSeedFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.928 5.429a.5.5 0 01.707-.008 5.878 5.878 0 011.562 2.67.5.5 0 01-.965.26 4.877 4.877 0 00-1.297-2.215.5.5 0 01-.007-.707z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.856 8.651a7.437 7.437 0 00-3.74-6.355 2.253 2.253 0 00-2.232 0 7.438 7.438 0 00-3.74 6.355c-1.198-.513-2.572-.784-4.123-.784-.552 0-1 .452-1 1.01 0 .427-.005.86-.01 1.294-.018 1.476-.037 2.967.152 4.328.252 1.821.885 3.55 2.423 4.988C6.882 21.632 9.37 22 12 22c2.63 0 5.118-.368 7.414-2.513 1.538-1.438 2.17-3.167 2.423-4.988.189-1.36.17-2.852.152-4.328-.005-.434-.01-.867-.01-1.295 0-.557-.448-1.01-1-1.01-1.55 0-2.925.272-4.123.785zm-4.723-4.597a.269.269 0 00-.266 0 5.416 5.416 0 00-2.724 4.71V9.86c.375.306.72.643 1.037 1.007.795.914 1.389 2.11 1.82 3.405.431-1.296 1.025-2.49 1.82-3.405.316-.364.662-.7 1.037-1.007V8.764c0-1.951-1.04-3.75-2.724-4.71z'
    />
  </svg>
)

export default SvgSeedFilled
